import React, { createContext, useContext, useState } from 'react';

const HostUpgradeContext = createContext();

export const useHostUpgrade = () => {
  const context = useContext(HostUpgradeContext);
  if (!context) {
    throw new Error('useHostUpgrade must be used within a HostUpgradeProvider');
  }
  return context;
};

export const HostUpgradeProvider = ({ children }) => {
  const [selectedPlan, setSelectedPlan] = useState(null);
  const [paymentIntentId, setPaymentIntentId] = useState(null);
  const [userPreferences, setUserPreferences] = useState({});

  const resetFlow = () => {
    setSelectedPlan(null);
    setPaymentIntentId(null);
    setUserPreferences({});
  };

  const value = {
    selectedPlan,
    setSelectedPlan,
    paymentIntentId,
    setPaymentIntentId,
    userPreferences,
    setUserPreferences,
    resetFlow,
  };

  return <HostUpgradeContext.Provider value={value}>{children}</HostUpgradeContext.Provider>;
};
